/**
 * Routes configuration for auth app
 */
import * as g from './guards';
import Login from '../components/Login';

/**
 * Application routes configuration
 * @type {Array.<object>}
 */
const routes = [
  {
    path:        '/login',
    name:        'login',
    component:   Login,
    beforeEnter: g.ifNotAuthenticated,
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/apps/auth/router/index.js